import { render, staticRenderFns } from "./ConsultaBuro.vue?vue&type=template&id=541b5ae0&"
import script from "./ConsultaBuro.vue?vue&type=script&lang=js&"
export * from "./ConsultaBuro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports